/* BW · product cards: size labels like "7.5 (EU38.5)" show the EU size, like the other cards and the product page default */
(function () {
  if (window.__bwxCards) return; window.__bwxCards = true;
  var RE = /^\s*[^()]+?\s*\(\s*EU\s*([^)]+)\)\s*$/i;
  function run() {
    var n = document.querySelectorAll('.m-product-card .js-variant');
    for (var i = 0; i < n.length; i++) { var m = RE.exec(n[i].textContent); if (m) n[i].textContent = m[1].trim(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('bwx:grid-updated', function () { setTimeout(run, 50); });
  setInterval(run, 1500);
})();
